export const blockIconsPrivacyandsecurityAssuredWorkloadNew = (
	<span className='material-symbols-outlined'>assured_workload</span>
);
